import { render } from "./TestWebhookDelivery.vue?vue&type=template&id=cf77bef4&scoped=true"
import script from "./TestWebhookDelivery.vue?vue&type=script&lang=js"
export * from "./TestWebhookDelivery.vue?vue&type=script&lang=js"

import "./TestWebhookDelivery.vue?vue&type=style&index=0&id=cf77bef4&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf77bef4"]])

export default __exports__